<template>
  <div>
    <logged-in-header />
    <bags-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import bagsPanel from "../components/bags/BagPanel";

export default {
  components: {
    loggedInHeader,
    bagsPanel
  }
};
</script>
